module.exports = __webpack_public_path__ + "static/media/Store Page Optional Banner.1463a758.jpg";